import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import DataFlowV2Service from "src/modules/data-protection/apis/DataFlowV2Service";

export const DATA_FLOW_OPTIONS_QUERY_KEY = "data-flow-options";

const useDataFlowOptions = ({ t } = {}) => {
    return useQuery({
        queryKey: [DATA_FLOW_OPTIONS_QUERY_KEY],
        queryFn: async () => {
            const service = DataFlowV2Service.getInstance();
            const response = await service.getOptions();

            return response?.data || {};
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching data flow options."), {
                type: "error",
            });
        },
    });
};

export default useDataFlowOptions;
